export default {
      id: "attachFile-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#attachFile-usage",
      toString: function () {
        return this.url;
      }
    }